module.exports = __webpack_public_path__ + "img/gh (5).24d72953.png";